"use client";

import HcpAccordion from '@/components-hcp/accordion';
import CustomImage from '@/components/image';
import styles from './_bmi-and-metabolic-health-data.module.scss';

export default function HcpClinicalInformationBMIAndMetabolicHealthData() {
  return (
    <section className={styles.bmi}>
      <HcpAccordion
        label={<>View BMI and metabolic health data</>}
      >
        <div className={`container ${styles.bmi_container}`}>
          <p className={`${styles.bmi_heading} h2`}>Enduring improvements in metabolic health</p>
          <p className={styles.bmi_subtitle}>
            Improvements in BMI in participants with overweight/obesity (change from baseline)<span className="super-asterisc">*</span><sup>&dagger;</sup>
          </p>
          <div className={styles.bmi_chart_row}>
            <div className={styles.bmi_chart}>
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet="/images/page/hcp/clinical-information/Clinical-Information_Adult-BMI-Improvements_mobile.svg"
                />
                <CustomImage
                  src='/images/page/hcp/clinical-information/Clinical-Information_Adult-BMI-Improvements.svg'
                  width={789}
                  height={516}
                  alt='In patients who were overweight or had obesity, BMI decreased by 0.4 in patients taking CRENESSITY vs a 0.3 decrease with placebo at 24 weeks.'
                />
              </picture>
            </div>
            <div className={styles.bmi_stat_card}>
              <div className={styles.bmi_stat_card_inner}>
                <span className={styles.bmi_stat_number}>37%</span>
                <p>of adults who were overweight or obese at baseline achieved &gt;5% decrease in body weight at 2 years.<sup>28</sup><span className="super-asterisc">*</span><sup>&sect;</sup></p>
              </div>
            </div>
          </div>
          <div className="hcp-callout">
            <div className={styles.bmi_callout_content}>
              <strong>43%</strong> of adults with insulin resistance (HOMA-IR &gt;2.5) at baseline were no longer insulin resistant at 2 years (n=34/56).<sup>28&dagger;</sup>
            </div>
          </div>
          <div className={styles.bmi_disclaimer}>
            <p>
              These secondary and prespecified exploratory endpoints were not adjusted for multiplicity; these descriptive results could represented chance findings.<sup>25</sup>
            </p>
          </div>
          <ul className={`footnotes ${styles.bmi_footnotes}`}>
            <li>
              <span className="hang">*</span>
              <span>Overweight/obesity was defined as BMI &ge;25 kg/m<sup>2</sup> at baseline.<sup>28</sup></span>
            </li>
            <li>
              <sup className="hang">&dagger;</sup>
              <span>Data for the 5 participants taking a GIP/GLP-1 receptor agonist (RA) at baseline were excluded from all time points. For the 4 others who took a GIP/GLP-1 RA during the trial, their data were excluded on and after starting CRENESSITY.<sup>28</sup></span>
            </li>
            <li>
              <sup className="hang">&Dagger;</sup>
              <span>The 24-month timepoint includes adults treated with CRENESSITY for 24 months, as well as patients who started the trial taking placebo and switched to CRENESSITY at month 6 (ie, patients treated with CRENESSITY for 18 months).<sup>8</sup></span>
            </li>
            <li>
              <sup className="hang">&sect;</sup>
              <span>At 2 years, 37% (n=35/95) of adults who were overweight or obese at baseline achieved &gt;5% decrease in body weight.<sup>28</sup></span>
            </li>
          </ul>
        </div>
      </HcpAccordion>
    </section>
  );
}
